import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/* Router Modules */
// import componentsRouter from './modules/components'
import tableRouter from "./modules/table";

/**
 * constantRoutes
 * 主场和 搭建商角色都可以访问的路由
 */
export const constantRoutes = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index"),
      },
    ],
  },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/views/error-page/404"),
    hidden: true,
  },
  {
    path: "/401",
    component: () => import("@/views/error-page/401"),
    hidden: true,
  },
  {
    path: "/dashboard",
    component: () => import("@/views/dashboard/index"),
    name: "Dashboard",
    hidden: true,
  },

  // {
  //   id: "/intserv/register",
  //   path: "/intserv/register",
  //   component: Layout,
  //   redirect: "/intserv/register",
  //   meta: { title: "注册资料", noCache: true, order: 2 },
  //   children: [
  //     {
  //       path: "index",
  //       component: () => import("@/views/intserv/register/index"),
  //       name: "register",
  //       meta: { title: "注册资料", noCache: true },
  //     },
  //     {
  //       path: "qualification",
  //       component: () => import("@/views/intserv/register/qualification.vue"),
  //       name: "qualification",
  //       meta: { title: "企业资质", noCache: true },
  //     },
  //   ],
  // },
  {
    path: "/exhibitionList",
    component: Layout,
    redirect: "/exhibitionList/exhibitionList",
    meta: { title: "展会列表", noCache: true, order: 3 },
    children: [
      {
        path: "/exhibitionList/exhibitionList",
        component: () => import("@/views/exhibition/exhibitionList.vue"),
        name: "exhibitionList",
        meta: { title: "展会列表", noCache: true },
      },
    ],
  },
  {
    path: "/exhibitionInfo",
    component: Layout,
    redirect: "/exhibitionList/exhibitionList",
    meta: { title: "展会信息", noCache: true, order: 4 },
    children: [
      {
        path: "/exhibitionInfo/exhibitionInfo",
        component: () => import("@/views/exhibition/exhibitionInfo.vue"),
        name: "exhibitionInfo",
        meta: { title: "展会信息", noCache: true },
      },
    ],
  },
];

// 主场角色路由
export const homeRoleRoutes = [
  {
    path: "/home",
    component: Layout,
    redirect: "/home/index",
    meta: { title: "首页", noCache: true, order: 1 },
    children: [
      {
        path: "index",
        component: () => import("@/views/home/index"),
        name: "Home",
        meta: { title: "首页", noCache: true, affix: true },
      },
    ],
  },
  {
    id: "/intserv/register",
    path: "/intserv/register",
    component: Layout,
    redirect: "/intserv/register",
    meta: { title: "注册资料", noCache: true, order: 2 },
    children: [
      {
        path: "index",
        component: () => import("@/views/intserv/register/index"),
        name: "register",
        meta: { title: "注册资料", noCache: true },
      },
      {
        path: "qualification",
        component: () => import("@/views/intserv/register/qualification.vue"),
        name: "qualification",
        meta: { title: "企业资质", noCache: true },
      },
    ],
  },
  {
    path: "/profile",
    component: Layout,
    redirect: "/profile/index",
    hidden: true,
    children: [
      {
        path: "index",
        component: () => import("@/views/profile/index"),
        name: "Profile",
        meta: { title: "profile", icon: "user", noCache: true },
      },
    ],
  },
  {
    id: "/exhibitionManagement",
    path: "/exhibitionManagement",
    name: "",
    component: Layout,
    redirect: "/exhibitionManagement",
    meta: { title: "展会管理", noCache: true },
    children: [
      {
        id: "/exhibitionManagement/exhibitor",
        path: "exhibitor",
        component: () => import("@/views/exhibitionManagement/exhibitor/index"),
        name: "exhibitor",
        meta: { title: "展位管理", noCache: true },
      },
      {
        path: "builder",
        component: () => import("@/views/exhibitionManagement/builder/index"),
        name: "builder",
        meta: { title: "搭建商管理", noCache: true },
      },
      {
        path: "/exhibitionManagement/exhibitionConfig",
        component: () =>
          import("@/views/exhibitionManagement/exhibitionConfig.vue"),
        name: "spaceconfig",
        meta: { title: "报馆配置", noCache: true },
      },
      {
        path: "serviceConfig",
        component: () =>
          import("@/views/exhibitionManagement/serviceConfig/index"),
        name: "serviceConfig",
        meta: { title: "服务配置", noCache: true },
      },
      {
        id: "/exhibitionManagement/fileConfig",
        path: "fileConfig",
        component: () =>
          import("@/views/exhibitionManagement/fileconfig/index"),
        name: "fileconfig",
        meta: { title: "文件配置", noCache: true },
      },
    ],
  },
  {
    path: "/registrationManagement",
    name: "",
    component: Layout,
    redirect: "/registrationManagement",
    meta: { title: "报馆管理", noCache: true },
    children: [
      {
        path: "/registrationManagement/registrationDeclaration",
        component: () =>
          import("@/views/registrationManagement/registrationDeclaration"),
        name: "registrationDeclaration",
        meta: { title: "报馆申报", noCache: true },
      },
      {
        path: "serviceApplication",
        id: "/registrationManagement/serviceApplication",
        component: () =>
          import("@/views/registrationManagement/serviceApplication"),
        name: "ServiceApplication",
        meta: { title: "服务申请", noCache: true },
      },
      {
        path: "certificateApply/person",
        component: () => import("@/views/certificateApply/person"),
        name: "certificateApplyPerson",
        meta: { title: "人证申请", noCache: true },
      },
      {
        path: "certificateApply/vehicle",
        component: () => import("@/views/certificateApply/vehicle"),
        name: "certificateApplyVehicle",
        meta: { title: "车证申请", noCache: true },
      },
      {
        path: "certificateApply/electron",
        component: () => import("@/views/certificateApply/electron"),
        name: "certificateApplyElectron",
        meta: { title: "电子车证管理", noCache: true },
      },
      {
        path: "overtimeApplication",
        component: () =>
          import("@/views/registrationManagement/overtimeApplication"),
        name: "OvertimeApplication",
        meta: { title: "加班申请", noCache: true },
      },
      {
        path: "reportAudit",
        id: "/registrationManagement/reportAudit",
        component: () => import("@/views/registrationManagement/reportAudit"),
        name: "reportAudit",
        meta: { title: "报馆审核", noCache: true },
      },
      {
        path: "serviceAudit",
        id: "/registrationManagement/serviceAudit",
        component: () => import("@/views/registrationManagement/serviceAudit"),
        name: "serviceAudit",
        meta: { title: "服务审核", noCache: true },
      },
      {
        path: "personCertAudit",
        component: () =>
          import("@/views/registrationManagement/personCertAudit/index.vue"),
        name: "personCertAudit",
        meta: { title: "人证审核", noCache: true },
      },
      {
        path: "carCertAudit",
        component: () =>
          import("@/views/registrationManagement/carCertAudit/index.vue"),
        name: "carCertAudit",
        meta: { title: "车证审核", noCache: true },
      },
      {
        path: "personCertQuery",
        component: () =>
          import("@/views/registrationManagement/personCertQuery/index.vue"),
        name: "personCertQuery",
        meta: { title: "人证查询", noCache: true },
      },
      {
        path: "carCertQuery",
        component: () =>
          import("@/views/registrationManagement/carCertQuery/index.vue"),
        name: "carCertQuery",
        meta: { title: "车证查询", noCache: true },
      },
    ],
  },
  {
    path: "/fileDownload",
    component: Layout,
    redirect: "/fileDownload",
    children: [
      {
        path: "/fileDownload",
        component: () => import("@/views/fileDownload/index.vue"),
        name: "fileDownload",
        meta: {
          title: "文件下载",
          noCache: true,
        },
      },
    ],
  },
  // {
  //   path: "/venue",
  //   component: Layout,
  //   redirect: "/venue",
  //   meta: { title: "物资管理", noCache: true },
  //   children: [
  //     {
  //       path: "/lease",
  //       component: () => import("@/views/venue/lease/index.vue"),
  //       name: "lease",
  //       meta: {
  //         title: "租赁管理",
  //         noCache: true,
  //       },
  //     },
  //     {
  //       path: "/inventory",
  //       component: () => import("@/views/venue/inventory/index.vue"),
  //       name: "inventory",
  //       meta: {
  //         title: "库存管理",
  //         noCache: true,
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: "/setupMangement",
  //   component: Layout,
  //   redirect: "/setupMangement",
  //   meta: { title: "搭建管理", noCache: true },
  //   children: [
  //     {
  //       path: "/boothacceptance",
  //       component: () => import("@/views/venue/boothacceptance/index.vue"),
  //       name: "boothacceptance",
  //       meta: {
  //         title: "展台验收",
  //         noCache: true,
  //       },
  //     },
  //     {
  //       path: "/dismantlinginspection",
  //       component: () =>
  //         import("@/views/venue/dismantlinginspection/index.vue"),
  //       name: "dismantlinginspection",
  //       meta: {
  //         title: "撤展验收",
  //         noCache: true,
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: "/contractManagement",
  //   component: Layout,
  //   redirect: "/contractManagement",
  //   name: "contractManagement",
  //   meta: { title: "合同管理", noCache: true },
  //   children: [
  //     {
  //       path: "contractManagement",
  //       id: "/contractManagement/contractManagement",
  //       component: () =>
  //         import("@/views/contractManagement/contractManagement"),
  //       name: "contractManagement",
  //       meta: { title: "合同管理", noCache: true },
  //     },
  //     {
  //       path: "contractPaymentPlan",
  //       id: "/contractManagement/contractPaymentPlan",
  //       component: () =>
  //         import("@/views/contractManagement/contractPaymentPlan"),
  //       name: "ContractPaymentPlan",
  //       meta: { title: "合同付款计划", noCache: true },
  //     },
  //   ],
  // },
  {
    id: "/financialManagement",
    path: "/financialManagement",
    component: Layout,
    redirect: "/financialManagement",
    name: "financialManagement",
    alwaysShow: true,
    meta: { title: "财务管理", noCache: true },
    children: [
      {
        path: "transactionOrder",
        id: "/financialManagement/transactionOrder",
        component: () => import("@/views/financialManagement/transactionOrder"),
        name: "TransactionOrder",
        meta: { title: "交易订单", noCache: true },
      },
      {
        path: "splitPayment",
        id: "/financialManagement/splitPayment",
        component: () =>
          import("@/views/financialManagement/splitPayment/index.vue"),
        name: "SplitPayment",
        meta: { title: "分账申请", noCache: true },
      },
      {
        path: "refundApply",
        id: "/financialManagement/refundApply",
        component: () =>
          import("@/views/financialManagement/refundApply/index.vue"),
        name: "refundApply",
        meta: { title: "退款申请", noCache: true },
      },
      {
        path: "billVerification",
        id: "/financialManagement/billVerification",
        component: () =>
          import("@/views/financialManagement/billVerification/index.vue"),
        name: "billVerification",
        meta: { title: "账单核对", noCache: true },
      },
    ],
  },
  {
    path: "/certificateDatabase",
    component: Layout,
    redirect: "/certificateDatabase/personDatabase",
    alwaysShow: true,
    meta: { title: "证件信息库", noCache: true },
    children: [
      {
        path: "personDatabase",
        component: () =>
          import("@/views/certificateDatabase/personDatabase/index.vue"),
        name: "personDatabase",
        meta: { title: "人员信息库", noCache: true },
      },
      {
        path: "vehicleDatabase",
        component: () =>
          import("@/views/certificateDatabase/vehicleDatabase/index.vue"),
        name: "vehicleDatabase",
        meta: { title: "车辆信息库", noCache: true },
      },
    ],
  },
  {
    path: "/systemManagement",
    component: Layout,
    redirect: "/systemManagement/userManagement",
    alwaysShow: true,
    meta: { title: "系统管理", noCache: true },
    children: [
      {
        path: "/systemManagement/userManagement",
        component: () =>
          import("@/views/systemManagement/userManagement/index.vue"),
        name: "userManagement",
        meta: { title: "用户管理", noCache: true },
      },
    ],
  },
  // 404 page must be placed at the end !!!
  { path: "*", redirect: "/home/index", hidden: true },
];
// 搭建商角色路由
export const builderRoleRoutes = [
  {
    id: "/intserv/register",
    path: "/intserv/register",
    component: Layout,
    redirect: "/intserv/register",
    meta: { title: "注册资料", noCache: true, order: 2 },
    children: [
      {
        path: "index",
        component: () => import("@/views/intserv/register/index"),
        name: "register",
        meta: { title: "注册资料", noCache: true },
      },
    ],
  },
  {
    path: "/home",
    component: Layout,
    redirect: "/home/index",
    meta: { title: "首页", noCache: true, order: 1 },
    children: [
      {
        path: "index",
        component: () => import("@/views/home/builder"),
        name: "BuilderHome",
        meta: { title: "首页", noCache: true, affix: true },
      },
    ],
  },
  {
    path: "/profile",
    component: Layout,
    redirect: "/profile/index",
    hidden: true,
    children: [
      {
        path: "index",
        component: () => import("@/views/profile/index"),
        name: "Profile",
        meta: { title: "profile", icon: "user", noCache: true },
      },
    ],
  },
  {
    id: "/officeManagement",
    path: "/officeManagement",
    name: "",
    component: Layout,
    redirect: "/officeManagement/officeApply",
    meta: { title: "报馆管理", noCache: true },
    children: [
      {
        path: "officeApply",
        component: () => import("@/views/officeManagement/officeApply/index"),
        name: "officeApply",
        meta: { title: "报馆申请", noCache: true },
      },
      {
        path: "serviceApply",
        component: () => import("@/views/officeManagement/serviceApply/index"),
        name: "serviceApply",
        meta: { title: "服务申请", noCache: true },
      },
      {
        path: "certificateApply/person",
        component: () => import("@/views/certificateApply/person"),
        name: "certificateApplyPerson",
        meta: { title: "人证申请", noCache: true },
      },
      {
        path: "certificateApply/vehicle",
        component: () => import("@/views/certificateApply/vehicle"),
        name: "certificateApplyVehicle",
        meta: { title: "车证申请", noCache: true },
      },
      {
        path: "personCertQuery",
        component: () =>
          import("@/views/registrationManagement/personCertQuery/index.vue"),
        name: "personCertQuery",
        meta: { title: "人证查询", noCache: true },
      },
      {
        path: "carCertQuery",
        component: () =>
          import("@/views/registrationManagement/carCertQuery/index.vue"),
        name: "carCertQuery",
        meta: { title: "车证查询", noCache: true },
      },
    ],
  },
  {
    path: "/fileDownload",
    component: Layout,
    redirect: "/fileDownload",
    children: [
      {
        path: "/fileDownload",
        component: () => import("@/views/fileDownload/index.vue"),
        name: "fileDownload",
        meta: {
          title: "文件下载",
          noCache: true,
        },
      },
    ],
  },
  {
    id: "/financialManagement",
    path: "/financialManagement",
    component: Layout,
    redirect: "/financialManagement",
    alwaysShow: true,
    meta: { title: "财务管理", noCache: true },
    children: [
      {
        path: "transactionOrder",
        id: "/financialManagement/transactionOrder",
        component: () => import("@/views/financialManagement/transactionOrder"),
        name: "TransactionOrder",
        meta: { title: "交易订单", noCache: true },
      },
      // {
      //   path: 'billVerification',
      //   id: "/financialManagement/billVerification",
      //   component: () => import('@/views/financialManagement/billVerification/index.vue'),
      //   name: 'billVerification',
      //   meta: { title: '账单核对', noCache: true },
      // },
    ],
  },
  // {
  //   path: "/systemManagement",
  //   component: Layout,
  //   redirect: "/systemManagement/userManagement",
  //   alwaysShow: true,
  //   meta: { title: "系统管理", noCache: true },
  //   children: [
  //     {
  //       path: "/systemManagement/userManagement",
  //       component: () =>
  //         import("@/views/systemManagement/userManagement/index.vue"),
  //       name: "userManagement",
  //       meta: { title: "用户管理", noCache: true },
  //     },
  //   ],
  // },
  // 404 page must be placed at the end !!!
  { path: "*", redirect: "/home/index", hidden: true },
];

const createRouter = (item) => {
  return new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });
};
const router = createRouter();

export function resetRouter(item) {
  const newRouter = createRouter(item);
  router.matcher = newRouter.matcher; // reset router
}

export default router;
